<template>
  <div class="publicMain">
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">

        <el-form-item label="服务类型">
          <el-select v-model="form.region" placeholder="请选择服务类型">
            <el-option label="社区养老服务" value="0"></el-option>
            <el-option label="机构养老服务" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务项目">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="服务时间">
          <el-col :span="11">
            <el-date-picker style="width:100%" type="date" placeholder="选择日期" v-model="form.date1"></el-date-picker>
          </el-col>
          <el-col :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-time-picker placeholder="选择时间" v-model="form.date2" style="width:100%"></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="add">新增</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" style="display:flex;justify-content: center;">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip
                class="item"
                style="color:#dd3020;"
                effect="light"
                content="删除"
                placement="top-start"
              >
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div v-else-if="item.type=='serviceType'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.serviceType==0">社区养老服务</el-tag>
                <el-tag v-if="scope.row.serviceType==1" type="success">机构养老服务</el-tag>
              </div>
            </div>
            <div v-else-if="item.type=='sex'">
              <div style="text-align:center;">
                <span v-if="scope.row.sex==0" type="success">男</span>
                <span v-if="scope.row.sex==1" type="primary">女</span>
              </div>
            </div>
            <div v-else-if="item.type=='nature'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="40%">
      <div style="width:100%; width: 90%;margin: 0px auto;">
        <el-form
          v-if="visible"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="服务类型" prop="serviceType">
            <el-select v-model="ruleForm.serviceType" placeholder="请选择服用疗程" style="width:60%">
                  <el-option label="社区养老服务" :value="0"></el-option>
                  <el-option label="机构养老服务" :value="1"></el-option>
             </el-select>
          </el-form-item>
          <el-form-item label="服务时间" prop="serviceTime">
            <el-date-picker
                style="width:60%"
                type="datetime"
                placeholder="选择日期"
                format="yyyy-MM-dd hh:mm:ss"
                value-format="yyyy-MM-dd hh:mm:ss"
                v-model="ruleForm.serviceTime"
              ></el-date-picker>
          </el-form-item>
          <el-form-item label="服务项目" prop="serviceItems">
            <el-input  v-model="ruleForm.serviceItems"></el-input>
          </el-form-item>
          <el-form-item label="服务时长(小时)" prop="duration">
            <el-input  v-model="ruleForm.duration"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="ruleForm.remarks"></el-input>
          </el-form-item>
          <div class="button">
            <div class="button-mid" v-if="title!='查看'">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
            <div class="button-mid" v-else style="justify-content: center;">
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  oldManHelpRecondEdit,
  oldManHelpRecondCheck,
  oldManHelpRecondList,
  oldManHelpRecondDelete,
} from "../api";
//救助管理
import request from "@/utils/request.js";

import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {

    upload
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {},
      fileList: [],
      typeImg: "",
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "servicePerson",
          label: "服务人员"
        },
        {
          prop: "serviceTime",
          label: "服务时间"
        },
        {
          type:'serviceType',
          prop: "serviceType",
          label: "服务类型"
        },
        {
          prop: "serviceAddress",
          label: "服务地点"
        },
        {
          prop: "serviceItems",
          label: "服务项目"
        },
        {
          prop: "duration",
          label: "服务时长(小时)"
        },
        {
          label: "操作",
          type: "button"
        }
      ],
      successImg(e) {
        this.fileList5 = e;
      },
      deleteImg(e) {
        this.fileList0 = e;
      },
      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      ruleForm: {},
      rulesDialog: {},
      rules: {
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "blur" },
        ],
        serviceTime: [
          { required: true, message: "请选择服务时间", trigger: "blur" },
        ],
        serviceItems: [
          { required: true, message: "请填写服务项目", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //查询
    onCheck() {
      this.oldManHelpRecondListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form
      });
      this.$message({
        message: "查询成功",
        type: "success"
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.oldManHelpRecondListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      this.$message({
        message: "重置成功",
        type: "success"
      });
    },
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.oldManHelpRecondListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.oldManHelpRecondListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到列表
    oldManHelpRecondListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldPeopleId: this.$route.query.id,
      });
      oldManHelpRecondList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.title = "新增";
      this.ruleForm = {};
      // this.$refs.ruleForm.clearValidate()
    },
    //查看
    check(e) {
      this.visible = true;
      this.getData(e.id);
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.visible = true;
      this.getData(e.id);
      this.title = "编辑";
    },

    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          oldManHelpRecondDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.oldManHelpRecondListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm = Object.assign({}, this.ruleForm, {
            oldPeopleId: this.$route.query.id,
          });
          oldManHelpRecondEdit(this.ruleForm).then((res) => {
            this.$message({
              type: "success",
              message: this.title == "新增" ? "新增成功" : "编辑成功",
            });
            this.visible = false;
            this.oldManHelpRecondListAPI();
          });
        }
      });
    },
    //回写数据
    getData(e) {
      oldManHelpRecondCheck({ id: e }).then((res) => {
        this.ruleForm = Object.assign({}, res.content, {});
      });
    },
  },
  created() {
    this.oldManHelpRecondListAPI();
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-radio {
  margin: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
</style>
